import { Heading5, Label, Paragraph } from '@entur/typography';
import dayjs from 'dayjs';
import { useIntl } from 'react-intl';

interface OperatingMessageProps {
  title?: string;
  fromDate?: string;
  toDate?: string;
  description?: string;
}

export const OperatingMessage = ({ title, fromDate, toDate, description }: OperatingMessageProps) => {
  const intl = useIntl();

  const fromDateFormatted = fromDate
    ? dayjs(fromDate).format('DD.MM.YYYY')
    : intl.formatMessage({ id: 'generalValues.unknown' });
  const toDateFormatted = toDate
    ? dayjs(toDate).format('DD.MM.YYYY')
    : intl.formatMessage({ id: 'generalValues.unknown' });

  return (
    <>
      {title && <Heading5>{title}</Heading5>}
      <Label>
        {fromDateFormatted} - {toDateFormatted}
      </Label>
      {description && <Paragraph>{description}</Paragraph>}
    </>
  );
};
